$ = jQuery.noConflict();

function gdprConsentCheck(consent_types) {
  if (typeof Cookies.get("henfield_gdpr_consent") !== "undefined" && !["0", "1"].includes(Cookies.get("henfield_gdpr_consent"))) {
    var gdpr_cookie = JSON.parse(Cookies.get("henfield_gdpr_consent"));
    if (gdpr_cookie.length > 1) {
      //if more than one item in array, i.e. if more than just essential cookies then check to see if cookie choices match consent types
      //checker checks to see if all elements from the second parameter (array) are inside the first parameter (array), if so then return true
      //i.e. if all consent types match the consent types stored in the cookie then return true as passing gdpr
      let checker = (arr, target) => target.every((v) => arr.includes(v));
      //console.log(checker(gdpr_cookie,consent_types));
      if (checker(gdpr_cookie, consent_types)) {
        //if consent types in cookie match that of function arg then return true as they match
        return true;
      } else {
        //items in cookie don't match items in function arg
        return false;
      }
    } else {
      //cookie = unconsented, return false, gdpr declined
      return false;
    }
  } else {
    //cookie hasn't been set yet, return false as they haven't explicitly accepted
    console.log("gdpr cookie not set");
    return false;
  }
}
window.gdprConsentCheck = gdprConsentCheck;

//create gdpr banner
var bannerGdpr = $("#banner-gdpr");
if (bannerGdpr.length) {
  bannerGdpr.prependTo("body");
}

//visited once
if (!Cookies.get("existing_henfield_user")) {
  Cookies.set("existing_henfield_user", 1, { expires: 365 });
}

//listeners for choice buttons

function handleCookieConsent(consentChoices, actionChoice) {
  // Set GDPR cookie with json array of choices
  Cookies.set("henfield_gdpr_consent", JSON.stringify(consentChoices), {
    expires: 365,
  });
  //Cookies.set("existing_henfield_user", 1, { expires: 365 });
  if ($(".banner-gdpr").length) {
    $(".banner-gdpr").fadeOut(1000);
  }

  $.ajax({
    url: gdprAjax.adminAjaxUrl,
    type: "post",
    data: {
      action: "post_insert_gdpr_data_into_db",
      choice: actionChoice,
      nonce: gdprAjax.nonce,
    },
    success: function (data) {
      console.log(data);
    },
    error: function (xhr, textStatus, error) {
      console.log(xhr.responseText);
      console.log(xhr.statusText);
      console.log(textStatus);
      console.log(error);
    },
  });

  // Reload page
  //window.location.href = window.location.pathname;

  return false;
}

$(".allow-all-henfield-cookies").on("click", function (e) {
  e.preventDefault();
  var consented_to_all = ["strictly_necessary", "functional_cookies", "performance_cookies", "marketing_cookies"];
  handleCookieConsent(consented_to_all, "accepted");
});

$(".decline-non-essential-henfield-cookies").on("click", function (e) {
  e.preventDefault();
  var consented_to_necessary = ["strictly_necessary"];
  handleCookieConsent(consented_to_necessary, "declined");
  //reload page to ensure declined consent is pushed to google
  console.log("refreshing page");
  window.location.href = window.location.pathname;
});

function deleteAllCookies() {
  var domains = ["henfield.local", "henfield.localsite", "henfieldstorage.co.uk", "www.henfieldstorage.co.uk", "wpengine.com", "henfieldstage.wpengine.com", "henfielddev.wpengine.com"];

  // loop through cookies
  for (let cookie of document.cookie.split(";")) document.cookie = cookie + ";expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;";

  // loop through domains
  for (let domain of domains) {
    // loop through cookies
    for (let cookie of document.cookie.split(";")) document.cookie = cookie + ";expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=" + domain + ";";
  }
}

function sendChoicesToDb() {
  var selected = [];
  $(".switch__checkbox:checked").each(function () {
    selected.push($(this).attr("id"));
  });
  var selected_checkboxes = Object.keys(selected).length;
  if (selected_checkboxes === 1) {
    //if only one item in array, user has declined gdpr as the one item is mandatory
    if ($.inArray("strictly_necessary", selected) != -1) {
      var gdpr_choice = "declined";
    }
  } else if (selected_checkboxes === 4) {
    //user accepted all gdpr
    var gdpr_choice = "accepted";
  } else if (selected_checkboxes > 1 && selected_checkboxes < 5) {
    //user has made choices which are partial
    var gdpr_choice = "partial";
  }
  $.ajax({
    url: gdprAjax.adminAjaxUrl,
    type: "post",
    data: {
      action: "post_insert_gdpr_data_into_db",
      choice: gdpr_choice,
      nonce: gdprAjax.nonce,
    },
    success: function (data) {
      console.log("ajax gdpr fired");
    },
    error: function (xhr, textStatus, error) {
      /*console.log(xhr.responseText);
      console.log(xhr.statusText);
      console.log(textStatus);
      console.log(error);*/
    },
  });
}

function processCookieChoices() {
  deleteAllCookies();
  sendChoicesToDb();
  //add choices into an array
  var checked_choices = $(".switch__checkbox:checked");
  var choices = [];

  checked_choices.each(function () {
    choices.push($(this).attr("id"));
  });

  //set GDPR cookie with json array of choices
  Cookies.set("henfield_gdpr_consent", JSON.stringify(choices), {
    expires: 365,
  });
  Cookies.set("existing_henfield_user", 1, { expires: 365 });

  //reload page
  //location.reload();
  //reload page with query string for popup
  //window.location.href = window.location.pathname+"?"+$.param({'gdprUpdated':'true'}); not in use due to issue with query string
  window.location.href = window.location.pathname;
}

$("#confirm-henfield-cookie-choices").on("click", processCookieChoices);

$(document).ready(function () {
  // Set a timeout to trigger after 10 seconds (adjust as needed)
  setTimeout(function () {
    if (!Cookies.get("henfield_gdpr_consent") && !Cookies.get("undecided_logged")) {
      // Log 'undecided' if no consent has been set and hasn't been logged before
      logUndecidedStatus();
    } else {
      console.log("undecided previously logged, or never set");
    }
  }, 20000);
});

function logUndecidedStatus() {
  // Set a cookie to indicate the user has been logged as 'undecided'
  Cookies.set("undecided_logged", "true", { expires: 365 });

  // Make an AJAX call to log the 'undecided' status to the database
  $.ajax({
    url: gdprAjax.adminAjaxUrl,
    type: "post",
    data: {
      action: "post_insert_gdpr_data_into_db",
      choice: "undecided",
      nonce: gdprAjax.nonce,
    },
    success: function (data) {
      console.log("Undecided status logged.");
    },
    error: function (xhr, textStatus, error) {
      console.error("Error logging undecided status: ", textStatus, error);
    },
  });
}
/*//display popup if query user has updated preferences
if (window.location.href.indexOf("gdprUpdated") > -1) {
  Swal.fire({
    title: 'Your cookie settings choices have been stored',
    text: 'Click OK to go to our homepage',
    icon: 'success',
  })
  .then(function() {
    //redirect to homepage
    window.location.href = gdprAjax.homeUrl;
  });
}*/

/* document.addEventListener("DOMContentLoaded", function () {
  function getCookieValue(cookieName) {
    let name = cookieName + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let cookieArray = decodedCookie.split(";");
    for (let i = 0; i < cookieArray.length; i++) {
      let cookie = cookieArray[i].trim();
      if (cookie.indexOf(name) === 0) {
        return cookie.substring(name.length, cookie.length);
      }
    }
    return "";
  }
  function pushConsentUpdate() {
    // Get the henfield_gdpr_consent cookie
    let cookieValue = getCookieValue("henfield_gdpr_consent");
    // Check if the cookie exists
    if (cookieValue) {
      try {
        // Parse the cookie value to an array
        let consentArray = JSON.parse(cookieValue);
        // Check if "marketing_cookies" is in the array
        if (consentArray.includes("marketing_cookies")) {
          // Push consent granted to datalayer
          console.log(
            "user accepted marketing GDPR - push consent granted to Google"
          );
          window.dataLayer.push({
            event: "updateConsent",
            marketingConsent: "granted",
          });
        } else {
          // Push consent denied to datalayer
          console.log(
            "user declined marketing GDPR - push consent denied to Google"
          );
          window.dataLayer.push({
            event: "updateConsent",
            marketingConsent: "denied",
          });
        }
      } catch (e) {
        console.error("Error parsing cookie value:", e);
      }
    } else {
      console.warn("henfield_gdpr_consent cookie not found.");
    }
  }

  if (window.dataLayer) {
    //ensure datalayer is available
    pushConsentUpdate();
  } else {
    //If datalayer not available retry after 50ms
    console.log("datalayer unavailable");
    setTimeout(pushConsentUpdate, 50);
  }
});
 */
